<template>
  <div class="container">
    <div class="main">
      <!-- banner开始 -->
      <div class="banner">
        <img src="@/assets/about_bg.png" alt="" />
        <div class="text">
          <h2>
            关于我们
            <br />
            <span>ABOUT US</span>
          </h2>
          <p>做更好的自己, 做更好的服务</p>
        </div>
      </div>
      <!-- banner结束 -->
      <!-- 公司介绍开始 -->
      <div class="about-block">
        <div class="about-title">
          <h2>南宁年盈航空客货服务有限责任公司</h2>
          <p>
            Nanning&nbsp;Nianying&nbsp;Aviation&nbsp;Passenger&nbsp;& Cargo&nbsp;Service&nbsp;LTD.
          </p>
        </div>
        <div class="flex-row flex-center content-block details">
          <div class="left">
            <img src="@/assets/about.jpg" alt="" />
          </div>
          <div class="right">
            <p>
              南宁年盈航空客货服务有限责任公司，简称年盈航空，2000
              年成立于广西南宁，注册资金2000万元人民币，是首批国家财政部指定的“公务机票”
              销售资质的航空售票公司之一。年盈航空二十多年来一直专注于企业差旅，聚焦差旅、旅游、
              会务三大业务板块，服务于广西、贵州省3000多家党政机关和企事业单位，为超过35
              万人员提供国际国内机票、火车票、酒店、租车等全方位服务。<br /><br />聚焦公司三大业务板块<br />一、差旅<br />国内、国际机票、酒店、租车、火车票、签证、差旅服务。<br />二、旅游<br />专项培训、单位定制旅游、团建旅游。<br />三、会务<br />会议会展<br /><br />公司业务分布<br />
              广西：覆盖14个地市及县份<br />
              贵州：覆盖6个地市及县份、3个州
            </p>
          </div>
        </div>
      </div>
      <!-- 公司介绍结束 -->
      <!-- 企业文化开始 -->
      <div class="culture-block">
        <div class="culture-title">
          <h2>企业文化</h2>
          <p>CORPORATE CULTURE</p>
        </div>
        <div class="flex-row flex-center details">
          <div class="item">
            <img src="@/assets/corporate2.png" alt="" />
            <p>我们的愿景</p>
            <span>成为全球公务服务领导品牌</span>
          </div>
          <div class="item">
            <img src="@/assets/corporate1.png" alt="" />
            <p>我们的使命</p>
            <span>服务中国公务走向世界</span>
          </div>
          <div class="item">
            <img src="@/assets/corporate3.png" alt="" />
            <p>我们的核心价值观</p>
            <span>诚信为本&nbsp;&nbsp;客户第一&nbsp;&nbsp;服务至上</span>
          </div>
        </div>
      </div>
      <!-- 企业文化结束 -->
      <!-- 荣誉资质开始 -->
      <div class="honor-block">
        <div class="honor-title">
          <h2>荣誉资质</h2>
          <p>HONOR AND QUALIFICATION</p>
        </div>
        <div class="flex-row details">
          <div class="item">
            <div class="bg">
              <img src="@/assets/softwcopr1.png" alt="" />
            </div>
            <p>年盈企业差旅预订软件</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/softwcopr2.png" alt="" />
            </div>
            <p>年盈差旅在线预订管理系统</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/softwcopr3.png" alt="" />
            </div>
            <p>年盈机票查询预订系统</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/softwcopr4.png" alt="" />
            </div>
            <p>年盈差旅数据交换系统</p>
          </div>
          
          
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_10.png" alt="" />
            </div>
            <p>2020年</p>
            <p>四川航空卓越贡献奖</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_11.png" alt="" />
            </div>
            <p>2020年</p>
            <p>山东航空优秀合作伙伴</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_12.png" alt="" />
            </div>
            <p>2020年</p>
            <p>中国南方航空最佳销售贡献</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_15.png" alt="" />
            </div>
            <p>2020年</p>
            <p>华夏航空区域优秀合作伙伴</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_16.png" alt="" />
            </div>
            <p>2020年</p>
            <p>深圳航空最佳客户奖</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_6.png" alt="" />
            </div>
            <p>&nbsp;</p>
            <p>天津航空核心合作商</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_13.jpg" alt="" />
            </div>
            <p>&nbsp;</p>
            <p>国际“一类” 航空售票资质</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_14.jpg" alt="" />
            </div>
            <p>&nbsp;</p>
            <p>国内“二类” 航空售票资质</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_17.png" alt="" />
            </div>
            <p>2018年</p>
            <p>山东航空最佳代理商</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_18.png" alt="" />
            </div>
            <p>2018年</p>
            <p>中国南方航空钻石代理人</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_19.png" alt="" />
            </div>
            <p>2019年</p>
            <p>中国南方航空集团客户优质服务商</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_9.png" alt="" />
            </div>
            <p>2019年</p>
            <p>山东航空优秀合作伙伴</p>
          </div>
          <!-- 2016 -->
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_4.jpg" alt="" />
            </div>
            <p>2016年</p>
            <p>中国南方航空代理人国内销售钻石奖</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_5.png" alt="" />
            </div>
            <p>2017年</p>
            <p>深圳航空最佳销售代理商</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_7.png" alt="" />
            </div>
            <p>2017年</p>
            <p>中国南方航空GP销售最佳服务商</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_8.png" alt="" />
            </div>
            <p>2017年</p>
            <p>中国南方航空代理人国内销售钻石奖</p>
          </div>
          <!-- 2011 -->
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_1.png" alt="" />
            </div>
            <p>2011年</p>
            <p>深圳航空钻石合作伙伴奖</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_20.png" alt="" />
            </div>
            <p>2015年</p>
            <p>北部湾航空最佳销售奖</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_2.png" alt="" />
            </div>
            <p>2016年</p>
            <p>北部湾航空最佳合作伙伴</p>
          </div>
          <div class="item">
            <div class="bg">
              <img src="@/assets/ry_3.jpg" alt="" />
            </div>
            <p>2016年</p>
            <p>深圳航空最佳客户服务商</p>
          </div>
        </div>
      </div>
      <!-- 荣誉资质结束 -->
      <!-- 合作伙伴开始 -->
      <div class="feat">
        <div class="feat-title">
          <h2>合作伙伴</h2>
          <p>COOPERATIVE PARTNER</p>
        </div>
        <div class="feat-box fixed-view">
          <div class="left-wrap">
            <ul
              class="tab-nav"
              v-for="(item, index) in tabs"
              :key="index"
              @mouseover="changActive(index)"
            >
              <li :class="{ 'nav-active': count === index }">
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="right-wrap">
            <ul>
              <li
                :class="{ 'centent-active': count === 0 }"
                class="tab-content"
              >
                <div class="tab-content-wrap">
                  <div class="box">
                    <img src="@/assets/img24.png" alt="广西壮族自治区公安厅" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img25.png" alt="中国人大" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img26.png" alt="中国政协" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img27.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img28.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img29.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img30.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img31.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img32.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img33.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img34.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img35.png" alt="" />
                  </div>
                </div>
              </li>
              <li
                :class="{ 'centent-active': count === 1 }"
                class="tab-content"
              >
                <div class="tab-content-wrap">
                  <div class="box">
                    <img src="@/assets/img16.png" alt="中国国际航空公司" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img17.png" alt="中国东方航空" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img18.png" alt="" />
                  </div>

                  <div class="box">
                    <img src="@/assets/img19.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img20.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img21.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img22.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img23.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img36.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img37.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img38.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img39.png" alt="" />
                  </div>
                </div>
              </li>
              <li
                :class="{ 'centent-active': count === 2 }"
                class="tab-content"
              >
                <div class="tab-content-wrap">
                  <div class="box">
                    <img src="@/assets/img5.png" alt="中国建设银行" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img4.png" alt="国药集团" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img8.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/logo_slyj.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img6.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img10.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img9.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img3.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img2.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img1.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/img11.png" alt="" />
                  </div>
                  <div class="box">
                    <img src="@/assets/logo_jcjs.png" alt="" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 合作伙伴结束 -->
      <!-- 企业风貌开始 -->
      <div class="features-block">
        <div class="features-title">
          <h2>企业风貌</h2>
          <p>CORPORATE FEATURES</p>
        </div>
        <div class="flex-row flex-center details">
          <div class="item">
            <img src="@/assets/features.jpg" alt="" />
            <p>年盈航空前台</p>
            <span></span>
          </div>
          <div class="item">
            <img src="@/assets/features2.jpg" alt="" />
            <p>年盈航空办公区域</p>
            <span></span>
          </div>
          <div class="item">
            <img src="@/assets/features3.jpg" alt="" />
            <p>年盈航空接待室</p>
            <span></span>
          </div>
        </div>
      </div>
      <!-- 企业风貌结束 -->
      <!-- 咨询开始 -->
      <consultView />
      <!-- 咨询结束 -->
    </div>
    <join/>
    <conference/>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      tabs: [
        { name: "政府机构" },
        { name: "航空公司" },
        { name: "中大型企业" },
      ],
      count: 0,
    };
  },
  created() {},
  computed: {},
  methods: {
    //tab切换
    changActive(index) {
      this.count = index;
    },
  },
  mounted() {
    this.$emit("childVal", 3);
  },
  destroy() {},
};
</script>
<style lang="less" scoped>
.title(@width,@site,@mb) {
  width: @width;
  text-align: @site;
  margin-bottom: @mb;
}
.h2(@color,@mb,@fs) {
  color: @color;
  margin-bottom: @mb;
  font-size: @fs;
}
.p(@fs,@color) {
  font-size: @fs;
  color: @color;
}
.main {
  width: 100%;
  .banner {
    width: 100%;
    overflow: hidden;
    position: relative;
    .text {
      position: absolute;
      margin: 0 auto;
      color: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 9;
      h2 {
        font-size: 2rem;
        margin-bottom: 20px;
        font-weight: 700;
        span {
          font-size: 1.3rem;
          color: #eaeaea;
          display: inline-flex;
          justify-content: center;
          margin-top: 10px;
        }
      }
      p {
        font-size: 1.2rem;
        color: #e2ebf4;
      }
     
    }
     img {
        width: 100%;
        height: 550px;
        object-fit: cover;
      }
  }
  .about-block {
    background: #fff;
    padding: 70px 0;
    .about-title {
      h2 {
        .h2(#333,15px,2rem);
      }
      p {
        .p(0.9rem,#666);
      }
      .title(100%,center,50px);
    }
    .content-block {
      width: 1240px;
      padding: 0 20px;
      margin: 0 auto;
    }
    .details {
      .left {
        width: 500px;
        margin-right: 60px;
        img {
          width: 100%;
        }
      }
      .right {
        width: 500px;
        p {
          font-size: 0.9rem;
          line-height: 1.6em;
          text-align: justify;
        }
      }
    }
  }
  .culture-block {
    padding: 70px 0;
    background: url(../../assets/corporate.png) 50%;
    background-size: 100% 100%;
    .culture-title {
      h2 {
        .h2(#fff,15px,2rem);
      }
      p {
        .p(0.9rem,#fff);
      }
      .title(100%,center,50px);
    }
    .details {
      width: 100%;
      align-items: flex-start;
      .item {
        text-align: center;
        width: 300px;
        img {
          width: 60px;
          margin: 0 auto;
        }
        p {
          color: #f85148;
          font-size: 0.9rem;
          font-weight: 700;
          margin: 20px 0;
          line-height: 1.2em;
        }
        span {
          display: block;
          color: #fff;
          font-size: 0.9rem;
          margin-bottom: 5px;
          line-height: 1.2em;
        }
      }
    }
  }
  .honor-block {
    background: #efefef;
    padding: 70px 0;
    .honor-title {
      h2 {
        .h2(#333,15px,2rem);
      }
      p {
        font-size: 0.9rem;
        color: #666;
      }
      .title(100%,center,50px);
    }
    .details {
      width: 1240px;
      flex-wrap: wrap;
      margin: 0 auto;
      padding: 0 20px;

      .item {
        margin-right: 20px;
        background: #fff;
        padding: 10px;
        width: 280px;
        margin-bottom: 10px;
        .bg {
          width: 100%;
          height: 188px;
          background-color: #eaeaea;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 188px;
            object-fit: contain;
          }
        }
        p {
          text-align: center;
          line-height: 1.2em;
          font-size: 0.9rem;
          font-weight: 700;
        }
      }
    }
  }
  .features-block {
    background: #fff;
    padding: 70px 0;
    .features-title {
      h2 {
        .h2(#333,15px,2rem);
      }
      p {
        .p(0.9rem,#666);
      }
      .title(100%,center,50px);
    }
    .details {
      width: 1240px;
      margin: 0 auto;
      padding: 0 20px;
      .item {
        width: 390px;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      p {
        line-height: 1.2em;
        font-size: 0.9rem;
        font-weight: 700;
        margin: 10px 0;
      }
      span {
        display: block;
        width: 55px;
        height: 2px;
        background: #f85148;
      }
    }
  }
}
.feat {
  background: url(../../assets/partner.png) no-repeat;
  background-size: 100% 100%;
  padding: 50px 0 70px;
  width: 100%;
  margin: 0 auto;
  .feat-title {
    h2 {
      .h2(#333,15px,2rem);
    }
    p {
      font-size: 0.9rem;
      color: #666;
    }
    .title(100%,center,50px);
  }
  .feat-box {
    width: 1240px;
    margin: 0 auto;
    .left-wrap {
      flex-basis: auto;
      white-space: nowrap;
      .tab-nav {
        li {
          display: block;
          text-align: center;
          line-height: 50px;
          height: 51px;
          font-weight: bold;
          font-size: 0.9rem;
          color: #333;
          margin: 10px 30px 0 0;
          border-radius: 5px;
          padding: 0 46px;
        }
      }
    }

    .centent-active {
      display: block !important;
    }
    .nav-active {
      background-color: #fff;
      color: #f22e30 !important;
    }
    .right-wrap {
      width: 100%;
      margin-top: 10px;
      .tab-content {
        display: none;
        .tab-content-wrap {
          display: flex;
          flex-wrap: wrap;
          .box {
            background-color: rgba(255, 255, 255, 1);
            border-radius: 5px;
            width: 200px;
            min-height: 79px;
            overflow: hidden;
            margin: 0 69px 30px 0;
            &:nth-child(4n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
